// extracted by mini-css-extract-plugin
module.exports = {"outerbox":"styles_outerbox__2RMoe","midtext":"styles_midtext__wQgFr","suggestionBox":"styles_suggestionBox__1SvOk"};